export const codeMotoGratuitData = {
  path: '/code-moto-gratuit',
  breadcrumb: [['Comprendre le Code Moto (ETM)', '/code-moto-gratuit']],
  kicker: 'Dossier magazine · Décryptage',
  title: 'Comprendre le Code Moto (ETM)',
  titleHighlight: 'ce qu\'il faut savoir.',
  subtitle:
    "Un dossier pédagogique 100 % gratuit pour comprendre l'Épreuve Théorique Moto : rôle, contenu officiel, opérateurs d'examen, articulation avec les livrets plateau et circulation.",
  seoTitle: 'Comprendre le Code Moto (ETM) — Dossier pédagogique CODE 2 ROUES',
  seoDescription:
    "Dossier magazine pour comprendre l'Épreuve Théorique Moto (ETM) : conditions, opérateurs officiels, articulation avec plateau et circulation. Rédigé par un moniteur ECSR. Pas de banque de questions.",
  seoKeywords:
    'magazine moto, comprendre ETM, permis A1, permis A2, permis 125, épreuve théorique moto, opérateurs agréés, ASSR 2, sécurité routière moto',
  heroImage:
    'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Motard en formation moto au sein d\'une auto-école',
  duration: 'Lecture 8 min',
  cost: '0 € — magazine 100 % gratuit',
  timeRequired: 'PT8M',
  about: 'Magazine pédagogique moto — comprendre l\'ETM (Épreuve Théorique Moto)',
  level: 'Beginner',
  primaryCta: { label: 'Voir tous les dossiers magazine', to: '/magazine' },
  secondaryCta: { label: 'Ouvrir le livret plateau', to: '/livret-plateau' },
  relatedTopic: 'magazine',

  intro:
    "<p>L'<strong>ETM</strong> (Épreuve Théorique Moto) est l'examen théorique <strong>obligatoire</strong> pour passer le permis A1, A2, ou pour conduire un 125 cm³ après 2 ans de permis B (formation 7h). Depuis 2020, c'est un examen <strong>distinct</strong> du Code voiture (ETG), avec son propre programme officiel.</p><p>Sur CODE 2 ROUES, nous ne proposons <strong>pas</strong> de banque de questions ni d'examens blancs. Nous sommes un <strong>magazine pédagogique</strong> : dossiers, enquêtes, livrets plateau et circulation, tutos vidéo. Notre rôle est de t'aider à <em>comprendre</em> les enjeux de la sécurité routière moto — la préparation à l'examen ETM est du ressort exclusif des <strong>opérateurs agréés par l'État</strong> et des éditeurs spécialisés.</p>",

  conditions: [
    {
      title: 'Âge minimum : 16 ans',
      text: "L'ETM est accessible dès 16 ans (permis A1). Pour le A2, il faut avoir 18 ans le jour de l'épreuve pratique.",
    },
    {
      title: 'ASSR 2 ou ASR',
      text: "Pour les candidats de moins de 21 ans nés après le 1er janvier 1988 : Attestation Scolaire de Sécurité Routière niveau 2 (3ᵉ) ou ASR pour les non-scolarisés.",
    },
    {
      title: 'Inscription auprès d\'un opérateur agréé',
      text: "L'ETM se passe uniquement dans un centre agréé par l'État (La Poste, SGS, Dekra, Bureau Veritas, Pearson VUE, Code'nGo!). Prix officiel : 30 € forfait national.",
    },
  ],

  steps: [
    {
      title: 'Comprendre les 9 thématiques du programme',
      duration: 'Lecture 15 min',
      text: "R (la route), C (la circulation), L (le conducteur), U (les autres usagers), D (notions diverses), M (mécanique), P (équipements de protection), E (l'environnement), S (premiers secours). Nos dossiers magazine couvrent chacune de ces thématiques sous forme d'articles éditoriaux.",
    },
    {
      title: 'Se former avec un moniteur ECSR',
      duration: '15 à 25 heures',
      text: "La formation théorique se fait normalement en auto-école avec un moniteur ECSR agréé. Nos livrets plateau et circulation viennent en <strong>complément</strong> pour ancrer les gestes techniques appris en cours.",
    },
    {
      title: 'Passer l\'ETM chez un opérateur agréé',
      duration: '30 minutes',
      text: "Inscription en ligne sur le site d'un opérateur agréé. 40 questions à choix multiples, examen sur tablette, résultat immédiat. La préparation aux QCM se fait via un éditeur spécialisé de ton choix — ce n'est pas notre métier.",
    },
    {
      title: 'Enchaîner sur le plateau et la circulation',
      duration: '20 à 35 heures',
      text: "Une fois l'ETM en poche, direction le plateau (6 manœuvres officielles) puis la circulation. Nos livrets interactifs t'accompagnent chapitre par chapitre.",
    },
  ],

  erreurs: [
    {
      title: 'Confondre CODE 2 ROUES et un préparateur ETG',
      text: "Nous ne sommes <strong>pas</strong> un site de préparation à l'ETM. Pour t'entraîner aux QCM officiels, adresse-toi à un éditeur spécialisé (auto-écoles ou plateformes dédiées).",
    },
    {
      title: 'Négliger les thèmes \"légers\"',
      text: "Les thèmes E (environnement) et S (premiers secours) sont moins visibles mais tombent souvent à l'examen. Nos dossiers y consacrent des articles entiers.",
    },
    {
      title: 'Sauter la formation moniteur',
      text: "L'ETM est technique. Passer par un moniteur ECSR (auto-école agréée) reste le chemin le plus sûr. Nos livrets sont des <em>compléments</em>, pas des substituts.",
    },
    {
      title: 'Confondre Code moto (ETM) et Code voiture (ETG)',
      text: 'Depuis 2020, ce sont deux examens séparés. Si tu as obtenu ton ETG il y a moins de 5 ans, tu es dispensé de l\'ETM. Au-delà, tu dois repasser.',
    },
  ],

  conseils: [
    "Lis nos dossiers magazine thématiques pour ancrer les notions clés.",
    "Ouvre le livret plateau interactif dès la 1ʳᵉ leçon à l'auto-école.",
    "Regarde nos vidéos officielles Sécurité Routière : ce sont des ressources publiques et gratuites.",
    "Pour la préparation aux QCM ETM : adresse-toi à ton auto-école ou à un éditeur spécialisé.",
    "En cas d'échec à l'ETM : dédramatise et reviens vers ton moniteur pour identifier les points faibles.",
  ],

  faq: [
    {
      q: 'CODE 2 ROUES propose-t-il des examens blancs ETM ?',
      a: "Non. CODE 2 ROUES est un <strong>magazine pédagogique</strong> : dossiers, enquêtes, livrets plateau et circulation, tutos. Nous ne proposons pas de banque de questions ETM ni d'examens blancs chronométrés. Pour cela, ton auto-école ou un éditeur spécialisé (Codes Rousseau, ENPC, etc.) sont les acteurs de référence.",
    },
    {
      q: 'Combien de questions y a-t-il à l\'examen ETM ?',
      a: "40 questions à choix multiples tirées parmi les 9 thèmes officiels. Tu as 30 secondes par question, soit 20 minutes au total. Seuil de réussite : 35/40 (maximum 5 erreurs).",
    },
    {
      q: 'Quel est le prix de l\'examen ETM ?',
      a: "30 € (forfait national). L'examen se passe uniquement dans un centre agréé (La Poste, SGS, Dekra, Bureau Veritas, Pearson VUE, Code'nGo). Notre magazine est 100 % gratuit.",
    },
    {
      q: 'Mon Code voiture est-il valable pour la moto ?',
      a: 'Si tu as obtenu ton ETG (code voiture) il y a moins de 5 ans, tu es dispensé de repasser l\'ETM pour le permis A1, A2 ou 125 cm³. Au-delà, tu dois passer l\'ETM séparément.',
    },
    {
      q: 'Quels sont les 9 thèmes officiels du Code moto ?',
      a: 'R (la route), C (la circulation), L (le conducteur), U (les autres usagers), D (notions diverses), M (mécanique et équipements), P (équipements de protection), E (l\'environnement), S (premiers secours). Chaque thème fait l\'objet d\'un dossier magazine sur CODE 2 ROUES.',
    },
    {
      q: 'Faut-il l\'ASSR 2 pour passer l\'ETM ?',
      a: 'Pour les candidats nés après le 1er janvier 1988 : oui, l\'ASSR 2 (passée en 3ᵉ) ou l\'ASR est obligatoire. Sans elle, l\'inscription est refusée par l\'auto-école.',
    },
  ],

  sourceLabel:
    'Programme officiel de l\'ETM, arrêté du 23 avril 2012 modifié (REMC), site Sécurité routière — sources publiques citées à titre pédagogique.',
  sourceUrl: 'https://www.securite-routiere.gouv.fr/passer-son-permis-de-conduire/permis-moto',
};
